import React from 'react';
import cn from 'classnames';
import i18n from 'i18next';

import { FlightSeatMapSegmentFragment, FlightStaticInfoFragment, SunSides } from '@websky/graphql';

import { getDurationString } from '../../../../../Results/utils';
import { SunIcon, TimeIcon } from '../../../../../Icons';

// TODO: move to /entities/aircraft/ui or /entities/flight/ui
import AircraftPopup from '../../../../../AircraftPopup';
import AircraftLivery from '../../../../../AircraftLivery';
import Amenities from '../../../../../Amenities';

import { AirplaneName, AirplaneOption } from './ui';

import { useIsMobile } from '../../../../../utils';
import { useTheme } from '../../../../../theme';

const labels: Record<SunSides, string> = {
	[SunSides.LeftSide]: i18n.t('SeatMap:90% on the left side'),
	[SunSides.RightSide]: i18n.t('SeatMap:90% on the right side'),
	[SunSides.NoneSide]: ''
};

interface Props {
	className?: string;
	sunSide: SunSides;
	segmentInfo: FlightSeatMapSegmentFragment['segmentsInfo'];
	amenities?: FlightStaticInfoFragment['amenities'];
	isReturnFlight?: boolean;
}

const FlightDetails: React.FC<Props> = ({ className, sunSide, segmentInfo, amenities, isReturnFlight }) => {
	const { FlightDetails: css } = useTheme('Entities').SeatMap;

	const isMobile = useIsMobile();
	const durationStr = segmentInfo.duration ? getDurationString(segmentInfo.duration) : null;
	const isNoneSide = sunSide === SunSides.NoneSide;

	return (
		<div
			className={cn(css.wrapper, className, {
				[css.noInfo]: !segmentInfo.aircraft?.name && !segmentInfo.aircraft?.icon
			})}
		>
			{segmentInfo.departure && segmentInfo.arrival && isMobile && (
				<div className={css.segment}>
					{segmentInfo.departure.airport.city.name}
					{' — '}
					{segmentInfo.arrival.airport.city.name}
				</div>
			)}

			<div className={css.top}>
				<AircraftLivery aircraft={segmentInfo.aircraft} className={css.image} isReturnFlight={isReturnFlight} />

				<div className={css.info__wrapper}>
					{segmentInfo.aircraft && (
						<AircraftPopup
							id={segmentInfo.aircraft.id}
							operatingIata={segmentInfo.operatingAirline?.iata}
							name={segmentInfo.aircraft.name}
							renderButton={onClick => (
								<AirplaneName text={segmentInfo.aircraft.name} onClick={onClick} />
							)}
						/>
					)}

					{!!amenities?.length && <Amenities className={css.amenities} amenities={amenities} />}
				</div>
			</div>

			<div
				className={cn(css.details, {
					[css.details_one]: isNoneSide
				})}
			>
				{durationStr && <AirplaneOption text={durationStr} icon={TimeIcon} />}

				{!isNoneSide && <AirplaneOption text={labels[sunSide]} icon={SunIcon} />}
			</div>
		</div>
	);
};

export default FlightDetails;
